import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modals } from 'modules/jobManager/components/modals';
import {
  getJobCreationTakeoverState,
  getJobManagerTableFilter,
  getJobManagerTablePagination,
  getJobManagerTableSort,
} from 'modules/jobManager/ducks/selectors';
import { fetchJobTableDataRequest } from 'modules/jobManager/ducks/actions';
import { FullWidth } from 'ui/utility/fullWidth';

import { JobManagerHeader, JobManagerTable, JobManagerTablePagination } from './sections';
import { PageContainer } from './Styled';
import { ExportJobCreationTakeover } from '../../takeovers';

export const JobManagerIndexPage = () => {
  const dispatch = useDispatch();
  const { jobStates, jobTypeNames } = useSelector(getJobManagerTableFilter);
  const { page, pageSize } = useSelector(getJobManagerTablePagination);
  const { sortBy, sortDirection } = useSelector(getJobManagerTableSort);
  const isExportJobCreationTakeoverOpen = useSelector(getJobCreationTakeoverState);

  useEffect(() => {
    dispatch(fetchJobTableDataRequest());
  }, [jobStates.length, jobTypeNames.length, page, pageSize, sortBy, sortDirection]);

  return (
    <PageContainer>
      <JobManagerHeader />
      <FullWidth>
        <JobManagerTable />
        <JobManagerTablePagination />
      </FullWidth>
      <Modals />
      {isExportJobCreationTakeoverOpen && <ExportJobCreationTakeover />}
    </PageContainer>
  );
};
